import { createFeatureSelector, createSelector } from '@ngrx/store'

import { EcommerceConfigState } from '../reducers/ecommerce.reducer'

export const selectEcommerceConfigState = createFeatureSelector<EcommerceConfigState>('ecommerceConfig')

export const selectEcommerceConfigProgramId = createSelector(
    selectEcommerceConfigState,
    (state) => state.respConfig.ID_Programa,
)

export const selectEcommerceConfigDefaultProductImage = createSelector(
    selectEcommerceConfigState,
    (state) => state?.respConfig?.ImagenProductoDefault || '',
)

